/** Confirm turning someone off, warning first about any project they are the only active owner of. */

import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/overlay";
import { plural } from "@/lib/format";
import type { UserDetail } from "./types";

export function DeactivateDialog({
  user,
  pending,
  onConfirm,
  onClose,
}: {
  user: UserDetail;
  pending: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const owned = user.projects.filter((p) => p.only_active_owner);
  const who = user.name || user.email;
  return (
    <Dialog
      title={`Deactivate ${who}?`}
      subtitle="They're signed out on their next click and can't open any project. Nothing they made is deleted, and you can reactivate them at any time."
      onClose={onClose}
      width={480}
      footer={
        <>
          <span className="flex-1" />
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={onConfirm} disabled={pending}>
            {pending ? "Deactivating…" : "Deactivate"}
          </Button>
        </>
      }
    >
      {owned.length > 0 ? (
        <div
          role="alert"
          className="flex flex-col gap-1.5 rounded-lg bg-warn-bg px-4 py-3 text-[13px] text-warn"
        >
          <p className="font-semibold">They're the only active owner of {plural(owned.length, "project")}:</p>
          <ul className="list-disc pl-5">
            {owned.map((p) => (
              <li key={p.id}>{p.name}</li>
            ))}
          </ul>
          <p>Until they're reactivated, nobody there can make someone else an owner.</p>
        </div>
      ) : (
        <p className="text-[13px] text-muted">{user.email}</p>
      )}
    </Dialog>
  );
}
